import { render } from "./trash.svg?vue&type=template&id=348d1683?inline"
const script = {}

import exportComponent from "/home/buddymetal/actions-runner/_work/candidate/candidate/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__